export default "/assets/images/awards-img-03-sm.5526c539dd540980.svg";